import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import _isNil from 'lodash/isNil';

import { getValueFromLocalStorage } from '../utils/common';
import Header from '../pages/signin/components/Header';

import { PublicWrapperContent } from './style';

type WrapperProps = {
  Content: React.ComponentType<any>;
  showHeader?: boolean;
};

const PublicWrapper = ({ Content, showHeader = true }: WrapperProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const token = getValueFromLocalStorage('userToken') || getValueFromLocalStorage('token');
  const boutique_id = getValueFromLocalStorage('boutique_id');

  useEffect(() => {
    // Only redirect to dashboard if:
    // 1. User has a token
    // 2. User has a valid boutique_id (> 0, not empty string)
    // 3. Not already on onboarding page (to allow onboarding flow)
    const hasValidBoutiqueId =
      !_isNil(boutique_id) && boutique_id !== '' && boutique_id !== 0 && boutique_id !== '0';

    if (
      !_isNil(token) &&
      token !== '' &&
      hasValidBoutiqueId &&
      location.pathname !== '/onboarding'
    ) {
      navigate('/dashboard');
    }
  }, [token, boutique_id, navigate, location.pathname]);

  return (
    <>
      {showHeader && <Header />}
      <PublicWrapperContent>
        <Content />
      </PublicWrapperContent>
    </>
  );
};

export default PublicWrapper;
